<template>
    <div class="view1Wrapper ">
        <div class="tipsGlobalText" v-html="tips">{{tips}}</div>
        <ul class="v1Items">
            <li v-for="(item,ix) in list" :key="`vi-0-${ix}`" @click="onRouter(item.type,item.value,item.name,item.id)">
                {{item.name}}
            </li>
        </ul>
    </div>
</template>
<script>
    import {mapState, mapActions, mapMutations} from "vuex";

    export default {
        name: "View1",
        components: {},
        props: {
            list: {
                type: Array,
                default: []
            },
            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                oContent: {}
            };

        },
        mounted() {
            this.oContent = document.querySelector(".chatting-content");
            this.oContent.scrollTop = this.oContent.scrollHeight;
        },
        methods: {
            ...mapActions([

            ]),
            ...mapMutations([
                "contactDisData"
            ]),

            onRouter(type, value, name, id) {
                let that = this;
                if (type == 3) {


                } else {
                    window.location.href = path;

                }

            }
        }
    };
</script>
<style lang="less" scoped>
    .view1Wrapper {


        min-width: 7rem;

        .title {
            font-family: PingFangSC-Regular, sans-serif;
            color: #333;
            font-size: .44rem;
            font-weight: 600;
            margin-bottom: .25rem;
        }

        .v1Items {
            padding: .4rem .6rem .4rem .8rem;
            background: #fff;
            box-shadow: -7px 0px 5px 0px rgba(0, 0, 0, 0.03);
            border-radius: .5rem .5rem .3rem .5rem;

            li {
                list-style-type: disc;
                color: #666;
                padding: 0.35rem 0 .35rem .4rem;
                font-size: 0.36rem;

            }

        }
    }

</style>
